import DOMPurify from 'dompurify';

/**
 * Sanitizes HTML for safe use with dangerouslySetInnerHTML.
 * Uses DOMPurify to strip scripts and other dangerous content.
 */
export function sanitizeHtml(html: string | null | undefined): string {
    return DOMPurify.sanitize(html ?? '');
}
